export default __webpack_public_path__ + "static/media/customer_white.ec61a3f3.svg";